<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="회사명(필수)"
      :options="[
        { type: 'text', label: '점검자', value: '점검자' },
        { type: 'date', label: '점검일(필수)', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <TableInspectMerge :is-print="isPrint" :is-readonly="board.readonly" :title="$t('예방 점검표')" contentBefore="•" v-model="form.inspectList" class="mt-28px" />

    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i>{{ $t("결재란") }}</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import { required } from "vuelidate/lib/validators";
import Print from "./Print.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
        점검자: { required },
        점검일: { required },
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "안전·보건 합동점검표",
      form: {
        stdInfo: {},

        fileList: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },

        inspectList: [
          {
            content: "<span class='font-normal'>사업장 내 위험한 밀폐공간을 파악하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제619조)</span>",
            isChecked: "",
            title: "밀폐공간 등 확인",
          },
          {
            content: "<span class='font-normal'>사업주 또는 책임자가 안전조치 사항을 확인한 후 작업하도록 하는 내부규정이 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제619조)</span>",
            isChecked: "",
            title: "밀폐공간 등 확인",
          },
          {
            content: "<span class='font-normal'>환기설비(송풍기 등), 송기마스크, 공기호흡기를 보유하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제620조)</span>",
            isChecked: "",
            title: "밀폐공간 등 확인",
          },
          {
            content: "<span class='font-normal'>밀폐공간 출입금지조치 및 경고표시를 하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제622조)</span>",
            isChecked: "",
            title: "밀폐공간 등 확인",
          },
          {
            content: "<span class='font-normal'>산소 및 유해가스 측정기를 보유하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제619조의2)</span>",
            isChecked: "",
            title: "산소 및 유해가스 측정",
          },
          {
            content:
              "<span class='font-normal'>작업 전 또는 작업 중에 산소 및 유해가스 농도 측정 및 적정공기 상태를 확인하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제619조의2)</span>",
            isChecked: "",
            title: "산소 및 유해가스 측정",
          },
          {
            content: "<span class='font-normal'>작업 전 또는 작업 중에 환기 및 송기마스크, 공기호흡기를 사용하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제620조)</span>",
            isChecked: "",
            title: "환기, 송기마스크 구비 등 조치",
          },
          {
            content: "<span class='font-normal'>밀폐공간 작업 시 입·출입 근로자 인원 점검을 하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제621조)</span>",
            isChecked: "",
            title: "환기, 송기마스크 구비 등 조치",
          },
          {
            content: "<span class='font-normal'>긴급구조훈련을 정기적으로 실시하고 있는지 (6개월 1회)</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제640조)</span>",
            isChecked: "",
            title: "환기, 송기마스크 구비 등 조치",
          },
          {
            content: "<span class='font-normal'>밀폐공간 작업 시 밀폐공간 외부에 감시인을 배치하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제623조)</span>",
            isChecked: "",
            title: "감시인 배치 및 교육",
          },
          {
            content: "<span class='font-normal'>작업 전 작업자 또는 감시인에게 안전한 작업방법에 대해 교육하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제641조)</span>",
            isChecked: "",
            title: "감시인 배치 및 교육",
          },
        ],
      },
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "회사명을 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검자"].required) return "점검자를 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검일"].required) return "점검일을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
